// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1cXyx","fullView":"styles_fullView__2sS4H"};